import { combineReducers } from 'redux';

import skillsSlice from './skills.reducer';
import skillDetailSlice from './skillDetail.reducer';

export default combineReducers({
    skillsSlice,
    skillDetailSlice
});
